var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectusr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.72 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #004080;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "livetype"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "9.27 18.2 13.84 22.77 21.45 15.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.36,36.5c-4-1.09-7.31-3.44-9.93-7.06-2.62-3.61-3.93-7.66-3.93-12.12V6.69L15.36,1.5l13.86,5.19v10.63c0,4.47-1.31,8.51-3.93,12.12-2.62,3.61-5.93,5.97-9.93,7.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectusr);
export default __webpack_public_path__ + "static/media/protectusr.cdab35da9aa13e5de315556a7b7efe0f.svg";
export { ForwardRef as ReactComponent };